import ja from "./ja";
import en from "./en";

const email = {
  en,
  ja
}
export default email;